export default {
	props: {
		avatar: {
			size: {
				type: Number,
				required: true,
				default: () => 60
			},
			icon: {
				type: String,
				required: true,
				default: () => ""
			}
		},

		title: {
			type: String,
			required: true,
			default: () => "Component title"
		},
		copy: {
			type: String,
			required: true,
			default: () => "Component copy"
		}
    }
};
